/*
 *
 *  Mixin - Global Variables
 */

// get version
import { version } from '../../package.json'

// global variables
export const gVars = {
  appVersion: version,
  appName: 'سينسز',
  appAltName: 'سينسز Senses',
  appShortDescription: 'إنتاج إبداعي',
  appDescription:
    'سينسز Senses هي شركة سعودية متخصصة في الصناعة الإعلامية، تقدم الحلول المتكاملة لمتطلبات الإنتاج الإعلامي.',
  appUrl: 'https://senses.sa',
  storageUrl: process.env.VUE_APP_STORAGE_URL,
  socialLinks: {
    twitter: {
      url: 'https://twitter.com/senses_sa'
    },
    instagram: {
      url: 'https://www.instagram.com/senses_sa/'
    }
  },
  brandUrls: {
    xs: '/assets/images/brands/card_h@xs.png',
    sm: '/assets/images/brands/card_h@sm.png',
    md: '/assets/images/brands/card_h@md.png',
    lg: '/assets/images/brands/card_h@lg.png'
  }
}

// export
export default {
  data: function() {
    return {
      get gVars() {
        return gVars
      }
    }
  }
}
